// extracted by mini-css-extract-plugin
export default {"gallery":"ImageGallery_gallery__DFfAV","imagesBox":"ImageGallery_imagesBox__EGUT9","arrowBox":"ImageGallery_arrowBox__I8keF","thumbnailsBox":"ImageGallery_thumbnailsBox__12JDw"};